import { RECEIVE_BACKEND_STATE } from "~/frontend/src/constants";

type ReceiveBackendStateAction = {
    type: typeof RECEIVE_BACKEND_STATE;
    dbEnvironment: string;
    wsEnvironment: string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} dbEnvironment
 * @param {String} wsEnvironment
 *
 * @return {ReceiveBackendStateAction}
 */
export const receiveBackendState = ( dbEnvironment: string, wsEnvironment: string ): ReceiveBackendStateAction => {
    return {
        type: RECEIVE_BACKEND_STATE,
        dbEnvironment,
        wsEnvironment
    };
}

export default receiveBackendState;
